"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.spinnerTypes = exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var loadingKeyframe = /*#__PURE__*/(0, _styledComponents.keyframes)(["0%,80%,100%{transform:scale(0);}40%{transform:scale(1.0);}"]);
var spinnerTypes = exports.spinnerTypes = {
  small: {
    width: 1
  },
  medium: {
    width: 1.8
  },
  large: {
    width: 2.4
  }
};
var Spinner = function Spinner(props) {
  var variant = spinnerTypes[props.size];
  return /*#__PURE__*/_react["default"].createElement(Spinner.container, {
    variant: variant
  }, /*#__PURE__*/_react["default"].createElement(Spinner.dot, (0, _extends2["default"])({}, props, {
    variant: variant,
    className: "bounce1"
  })), /*#__PURE__*/_react["default"].createElement(Spinner.dot, (0, _extends2["default"])({}, props, {
    className: "bounce2",
    variant: variant
  })), /*#__PURE__*/_react["default"].createElement(Spinner.dot, (0, _extends2["default"])({}, props, {
    className: "bounce3",
    variant: variant
  })));
};
Spinner.container = _styledComponents["default"].div.withConfig({
  componentId: "sc-8305g3-0"
})(["display:inline-flex;vertical-align:middle;align-items:center;justify-content:center;width:", "rem;text-align:center;"], function (props) {
  return 4 * props.variant.width;
});
Spinner.dot = _styledComponents["default"].div.withConfig({
  componentId: "sc-8305g3-1"
})(["width:", "rem;height:", "rem;background-color:", ";border-radius:100%;margin-right:0.2rem;display:inline-block;-webkit-animation:", " 1.4s infinite ease-in-out both;animation:", " 1.4s infinite ease-in-out both;&.bounce1{-webkit-animation-delay:-0.32s;animation-delay:-0.32s;}&.bounce2{-webkit-animation-delay:-0.16s;animation-delay:-0.16s;}&.bounce3{}"], function (props) {
  return props.variant.width;
}, function (props) {
  return props.variant.width;
}, function (props) {
  return props.color;
}, loadingKeyframe, loadingKeyframe);
Spinner.propTypes = {
  inverse: _propTypes["default"].bool,
  /** Color could be a hex code or a string*/
  color: _propTypes["default"].string,
  size: _propTypes["default"].oneOf(["small", "medium", "large"])
};
Spinner.defaultProps = {
  inverse: false,
  size: "small",
  color: "rgba(0,0,0)"
};
var _default = exports["default"] = Spinner;